import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { FaireAcademyContent } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/OpenUpShopWithConfidence/FaireAcademyContent";
import { FAInnerWrapperColumn } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import React from "react";

export const OpenUpShopWithConfidence: React.FC = () => {
  const { pageState } = useGetFaireAcademyPageState();

  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.MASTER_FUNDAMENTALS
    )
  );

  return (
    <FAInnerWrapperColumn ref={ref}>
      <FaireAcademyContent />
    </FAInnerWrapperColumn>
  );
};
